import React, { Fragment, useEffect, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Card, CardBody, Col, CardFooter, Row } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import ReactTableGeneric from "Components/ReactTableGeneric";
import Loader from "react-loaders";
import { useSmsStatistics, useSmsYears } from "Api/Admin/Sms";

const Sms = () => {
    const [selectedYear, setSelectedYear] = useState('');


    const {
        data: yearsResponse,
        isLoading: yearsLoading,
    } = useSmsYears();

    useEffect(() => {
        const fetchedYears = yearsResponse?.data?.years || [];

        if (fetchedYears.length > 0 && !selectedYear) {
            setSelectedYear(fetchedYears[0]);
        }
    }, [yearsResponse, selectedYear]);

    const {
        data: smsResponse,
        isLoading: smsLoading,
    } = useSmsStatistics(selectedYear);

    const years = yearsResponse?.data?.years || [];
    const smsData = smsResponse?.data|| [];
    const totalCount=smsResponse ||[];

    const columns = React.useMemo(
        () => [
            {
                header: () => 'Bestuur',
                accessorKey: 'vCommunityName'
            },
            {
                header: () => 'Totaal aantal SMS verzonden',
                accessorKey: 'cntSended'
            },
            {
                header: () => 'Totaal aantal credits',
                accessorKey: 'cntCredits'
            },
        ],
        []
    );

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <Row>
                    <Col md="12">
                        <Card className="main-card mb-3">
                            <CardBody className="p-3">
                                {yearsLoading || (selectedYear && smsLoading) ? (
                                    <Loader
                                        type="ball-grid-pulse"
                                        className={'mt-3 d-flex mx-auto justify-content-center'}
                                    />
                                ) : (
                                    <ReactTableGeneric
                                        data={smsData}
                                        columns={columns}
                                        tableClassName="mb-0 table table-borderless table-sm table-hover tb-links"
                                        filters={{ search: true, pagination: false, sorting: false }}
                                        count={totalCount}
                                    />
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </TransitionOnLoad>
            <div className="chat-layout-footer verzoken-footer-height">
                <CardFooter className="chat-layout-footer__inner">
                    <select
                        className="form-select w-auto"
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                    >
                        <option value="" disabled>
                            Jaar
                        </option>
                        {years?.map((item) => (
                            <option key={item} value={item}>
                                {item}
                            </option>
                        ))}
                    </select>
                </CardFooter>
            </div>
        </Fragment>
    );
};
export default Sms;

